import apiClient from '../utils/apiClient';

const base = (fid) => `/api/facilities/${fid}/workflows`;

const workflowsService = {
  pills: (fid) => apiClient.get(`${base(fid)}/pills`),
  // templates
  listTemplates: (fid) => apiClient.get(`${base(fid)}/templates`),
  getTemplate: (fid, id) => apiClient.get(`${base(fid)}/templates/${id}`),
  createTemplate: (fid, data) => apiClient.post(`${base(fid)}/templates`, data),
  updateTemplate: (fid, id, data) => apiClient.patch(`${base(fid)}/templates/${id}`, data),
  deleteTemplate: (fid, id) => apiClient.delete(`${base(fid)}/templates/${id}`),
  // forms
  uploadForm: (fid, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiClient.post(`${base(fid)}/forms`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  // runs
  listRuns: (fid) => apiClient.get(`${base(fid)}/runs`),
  getRun: (fid, id) => apiClient.get(`${base(fid)}/runs/${id}`),
  startRun: (fid, data) => apiClient.post(`${base(fid)}/runs`, data),
  markStepDone: (fid, runId, stepKey, values) =>
    apiClient.post(`${base(fid)}/runs/${runId}/steps/${stepKey}/done`,
      values ? { values } : undefined),
  skipTo: (fid, runId, stepKey) =>
    apiClient.post(`${base(fid)}/runs/${runId}/skip-to/${stepKey}`),
  cancelRun: (fid, runId) => apiClient.post(`${base(fid)}/runs/${runId}/cancel`),
};

export default workflowsService;
